import { ServiceFailureContextHookType } from "@zenith/context/global-context/types";
import { Dispatch, SetStateAction } from "react";

/**
 * Validate if the parameter is undefined
 * @function createValidator that uses as @param ServiceFailureContextHookType
 * @returns a @function () with:
 * @param field <Type> parameter that will be validated using generic type
 * @param propertyName to show the name of property that is undefined
 * @param setState Dispatch<SetStateAction<boolean>> an optional param if you need to validate a form
 * @returns the field if not undefined, else will throw a error
 * and if a mandatory field fail the validation, will return an screen error
 */

export function createValidator(context: ServiceFailureContextHookType) {
  return <Type>(
    field: Type | undefined,
    propertyName: string,
    setState?: Dispatch<SetStateAction<boolean>>
  ) => {
    if (!field) {
      setState && setState(false);
      context.setServiceFailureContext(true);
      throw new Error(propertyName + " is undefined");
    }

    setState && setState(true);
    context.setServiceFailureContext(false);
    return field;
  };
}
